import { render, staticRenderFns } from "./FundsSumBlock.vue?vue&type=template&id=397f51d7&scoped=true"
import script from "./FundsSumBlock.vue?vue&type=script&lang=js"
export * from "./FundsSumBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397f51d7",
  null
  
)

export default component.exports